import React, { useEffect, useState } from "react";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import NumberFormat from "react-number-format";
import { getSalesCards } from "../../../../services/crm/salesCardService";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
const SearchSalesCard = ({ onSelectSalesCard }) => {
  const { reload } = useGlobalData();
  const [salesCards, setSalesCards] = useState([]);
  useEffect(() => {
    getSalesCardsData();
  }, [reload]);
  return (
    <CustomDataTableSearch
      data={salesCards}
      onRefreshData={() => {
        getSalesCardsData();
      }}
      onSelectedData={(rowData, originalEvent) => {
        onSelectSalesCard(rowData);
      }}
      columns={[
        {
          field: "select",
          body: (rowData) => (
            <React.Fragment>
              <button
                type="button"
                className="btn btn-label-success btn-sm btn-pill btn-bold"
                onClick={() => onSelectSalesCard(rowData)}
              >
                Select <i className="fas fa-angle-double-right"></i>
              </button>
            </React.Fragment>
          ),
        },
        {
          header: "Sales Card ID",
          field: "ID",
          body: null,
          sortable: true,
        },
        {
          header: "Sales Card Name",
          field: "title",
          body: (rowData) => (
            <React.Fragment>
              <ResponsiveEllipsis text={rowData.title} maxLine="1" />
            </React.Fragment>
          ),
          sortable: true,
        },
        {
          header: "Type",
          field: "customerTypeDesc",
          body: (rowData) => (
            <React.Fragment>
              <ResponsiveEllipsis text={rowData.customerTypeDesc} maxLine="1" />
            </React.Fragment>
          ),
          sortable: true,
        },
        {
          header: "Name",
          field: "lead.leadName",
          body: (rowData) => (
            <React.Fragment>
              {rowData.customerID > 0 ? (
                <ResponsiveEllipsis
                  text={rowData.customer.customerName}
                  maxLine="1"
                />
              ) : (
                <ResponsiveEllipsis text={rowData.lead.leadName} maxLine="1" />
              )}
            </React.Fragment>
          ),
          sortable: true,
          hidden: true,
        },
        {
          header: "Name",
          field: "customer.customerName",
          body: (rowData) => (
            <React.Fragment>
              {rowData.customerID > 0 ? (
                <ResponsiveEllipsis
                  text={rowData.customer.customerName}
                  maxLine="1"
                />
              ) : (
                <ResponsiveEllipsis text={rowData.lead.leadName} maxLine="1" />
              )}
            </React.Fragment>
          ),
          sortable: true,
        },
        {
          header: "Currency",
          field: "currency.currencyCode",
          body: null,
          sortable: true,
          hidden: true,
        },
        {
          header: "Estimated Value",
          field: "estimatedValue",
          body: (rowData) => (
            <NumberFormat
              value={rowData.estimatedValue}
              displayType={"text"}
              thousandSeparator={true}
              decimalScale={2}
              renderText={(value) => (
                <div className="float-right">
                  {rowData.currency.currencyCode} {value}
                </div>
              )}
            />
          ),
          sortable: true,
        },
      ]}
    />
  );

  async function getSalesCardsData() {
    const response = await getSalesCards();
    const { data } = response.data;
    setSalesCards(data.salesCards);
  }
};

export default SearchSalesCard;
